(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("../../utils/BlockFormControlLayout"));
	else if(typeof define === 'function' && define.amd)
		define(["../../utils/BlockFormControlLayout"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("../../utils/BlockFormControlLayout")) : factory(root["../../utils/BlockFormControlLayout"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__2__) {
return 